var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex pa-8 text-center flex-column"},[_c('v-icon',{staticClass:"mb-4",attrs:{"x-large":"","color":"red"}},[_vm._v("mdi-alert-circle-outline")]),_c('h3',[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }